import Listener from "@bbx/listener~master/core/ts/Listener";

export const eventService = new Listener()
